import * as React from "react";
import pluginRegistry, {ActionEditProps} from "../pluginRegistry";
import {BaseComponent} from "components/BaseComponent/BaseComponent";
import SpecialVariables from "client/specialVariables";
import {ActionSummaryProps} from "../actionSummaryProps";
import {ActionExecutionLocation} from "client/resources/actionExecutionLocation";
import {PackageSelectorProperties} from "components/PackageSelector/PackageSelector";
import {PackageDownloadOptionsProperties} from "components/PackageDownloadOptions/PackageDownloadOptions";
import TomcatFeatureTemplate, {TomcatDeployProperties} from "./tomcatFeatureTemplate";
import {getFeedName} from "../getFeedName";
import Roles from "components/Actions/Roles";
import { TargetRoles } from "areas/projects/components/DeploymentProcess/ActionDetails";

interface ChangeStateInTomcatSummaryState {
    feedName: string;
}

class ChangeStateInTomcatActionSummary extends BaseComponent<ActionSummaryProps, ChangeStateInTomcatSummaryState> {
    constructor(props: any) {
        super(props);
        this.state = {feedName: null};
    }

    async componentDidMount() {
        this.setState({feedName: await getFeedName(this.getFeedId())});
    }

    render() {
        return <div>
            Change the state of an application in Tomcat 7+ {this.props.targetRolesAsCSV &&
        <span> to deployment targets in <Roles rolesAsCSV={this.props.targetRolesAsCSV}/> </span>}
        </div>;
    }

    private getFeedId() {
        return this.props.properties[SpecialVariables.Action.Package.FeedId] as string;
    }
}

interface ChangeStateInTomcatProperties extends PackageSelectorProperties, PackageDownloadOptionsProperties, TomcatDeployProperties {

}

export class ChangeStateInTomcatActionEdit extends BaseComponent<ActionEditProps<ChangeStateInTomcatProperties>, {}> {
    render() {
        const properties = this.props.properties;
        return <TomcatFeatureTemplate
            properties={this.props.properties}
            plugin={this.props.plugin}
            setProperties={this.props.setProperties}
            doBusyTask={this.props.doBusyTask}
            getFieldError={this.props.getFieldError}
            errors={this.props.errors}
        />;
    }
}

pluginRegistry.registerDeploymentAction({
    executionLocation: ActionExecutionLocation.AlwaysOnTarget,
    actionType: "Octopus.TomcatState",
    summary: (properties, targetRolesAsCSV) => <ChangeStateInTomcatActionSummary properties={properties}
                                                                                 targetRolesAsCSV={targetRolesAsCSV}/>,
    edit: ChangeStateInTomcatActionEdit,
    canHaveChildren: (step) => true,
    canBeChild: true,
    targetRoleOption: TargetRoles.Optional,
    hasPackages: (action) => true,
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Actions/tomcat/changeStateInTomcatAction.tsx